import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';
import {
  SrcNotificationSetting,
  SrcNotificationSettingResponse,
} from './src-notification-settings.model';

@Injectable()
export class SrcNotificationSettingsApi {
  private readonly endpointPrefix = 'iot/v1/notification-orchestrator/installations';

  constructor(private clientService: ClientService) {}

  getNotificationSetting(
    installationId: number,
    type: string
  ): Observable<SrcNotificationSettingResponse> {
    const endpoint = `${this.endpointPrefix}/${installationId}/notificationSettings/${type}`;

    return this.clientService.get(endpoint);
  }

  setNotificationSetting(
    installationId: number,
    type: string,
    isEnabled: boolean,
    threshold: string
  ): Observable<SrcNotificationSettingResponse> {
    const endpoint = `${this.endpointPrefix}/${installationId}/notificationSettings/${type}`;
    const body: Pick<SrcNotificationSetting, 'isEnabled' | 'threshold'> = { isEnabled, threshold };

    return this.clientService.post(endpoint, body);
  }
}
